import React from 'react';
import ExternalLink from '~/components/ExternalLink';
import { getAppContext } from '~/lib/AppContext';

interface EmailHelpTextProps {
    variant?: 'find' | 'sent';
}

export function EmailHelpText({ variant = 'find' }: EmailHelpTextProps) {
    const { supportEmail, supportSite } = getAppContext().config;
    const leadIn =
        variant === 'sent'
            ? "Didn't receive an email? Check your junk folder and search "
            : "Can't find your email address? Search ";
    return (
        <>
            {leadIn}
            your inboxes for emails from {supportEmail}, or{' '}
            <ExternalLink href={supportSite}>contact support</ExternalLink>.
        </>
    );
}
